module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content-boxed",
    attrs: {
      "id": "page-container"
    }
  }, [_c('main', {
    attrs: {
      "id": "main-container"
    }
  }, [_c('div', {
    staticClass: "bg-grey"
  }, [_c('div', {
    staticClass: "hero-static content content-full bg-grey"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center px-5"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6"
  }, [_c('div', {
    staticClass: "block"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-12",
    attrs: {
      "for": "login-username"
    }
  }, [_vm._v("Gebruikersnaam")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "login-username",
      "placeholder": "Vul je gebruikersnaam in...",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-12",
    attrs: {
      "for": "login-password"
    }
  }, [_vm._v("Wachtwoord")]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "login-password",
      "placeholder": "Vul je wachtwoord in...",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('label', {
    staticClass: "css-control css-control-sm css-control-primary css-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remember),
      expression: "remember"
    }],
    staticClass: "css-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.remember) ? _vm._i(_vm.remember, null) > -1 : (_vm.remember)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.remember = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.remember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.remember = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "css-control-indicator"
  }), _vm._v(" Ingelogd blijven\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-block btn-hero btn-noborder btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "si si-login mr-10"
  }), _vm._v("\n                        Log in\n                      ")])])])])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-30 px-5 text-center"
  }, [_c('a', {
    staticClass: "link-effect font-w700",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "si si-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-size-xl text-primary-dark"
  }, [_vm._v("VM")]), _c('span', {
    staticClass: "font-size-xl"
  }, [_vm._v("Control")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Inloggen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-content text-center"
  }, [_c('img', {
    staticClass: "img-avatar img-avatar96 img-avatar-thumb",
    attrs: {
      "src": "/static/img/avatar.jpg",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-219ecf7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/auth/LoginPage.vue
// module id = 697
// module chunks = 1